import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Pricing.css";
import Footer from "./Footer";
import { Alert, Snackbar } from "@mui/material";

import { apiService } from "../utils/api";

const Pricing = () => {
  const [plans, setPlans] = useState([]);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  useEffect(() => {
    fetchPlans();
  }, []);

  const fetchPlans = async () => {
    try {
      const response = await apiService.plans();
      setPlans(response.data.data);
    } catch (error) {
      showSnackbar("Error fetching plans", "error");
    }
  };

  const showSnackbar = (message, severity = "success") => {
    setSnackbar({
      open: true,
      message,
      severity,
    });
  };

  return (
    <>
      <div className="pricing-container">
        {/* Hero Section */}
        <section className="pricing-hero">
          <h1>Affordable Shorthand Training Packages</h1>
          <p>Invest in your future with our comprehensive stenography courses designed to fit every budget and learning goal</p>
        </section>

        {/* Pricing Plans */}
        <section className="pricing-plans">
          <div className="pricing-grid">
            {/* Basic Plan */}

            {plans.map((plan) => (
              <div className="pricing-card">
                <div className="pricing-header">
                  <h2>{plan.name}</h2>
                  <div className="pricing-amount">
                    <span className="currency">₹</span>
                    <span className="amount">{plan.price}</span>
                  </div>
                  <p className="pricing-duration">{plan.duration} month access</p>
                </div>
                <div className="pricing-features">
                  <ul>
                    {plan.features.map((feature) => (
                      <li>{feature}</li>
                    ))}
                  </ul>
                </div>
                <div className="pricing-footer">
                  <Link to="/subscription" className="btn btn-outline">
                    Enroll Now
                  </Link>
                </div>
              </div>
            ))}

            {/* Add other pricing cards here */}
          </div>
        </section>

        {/* Rest of the component */}
      </div>
      <Footer />

      <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={() => setSnackbar({ ...snackbar, open: false })}>
        <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Pricing;
